import { render } from "./TransactionRequestMaster.vue?vue&type=template&id=c6b8564a&scoped=true&lang=true"
import script from "./TransactionRequestMaster.vue?vue&type=script&lang=js"
export * from "./TransactionRequestMaster.vue?vue&type=script&lang=js"

import "./TransactionRequestMaster.vue?vue&type=style&index=0&id=c6b8564a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b8564a"]])

export default __exports__